import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Form, FormGroup, Label, Input, Button, Row, Col } from "reactstrap";
import RightSide from ".././.././../assets/images/RightSide.png";
import "../styles/LoginStyle.css";
import ".././.././../styles/CommonStyles.css";
import strings from "../../../utils/Strings";
import {
  validateEmailAddress,
  validateEmailAddressLoginPage,
  validatePassword,
  // validateUid, // Add UID validation function
} from "../../../utils/Validation";
import Logger from "../../../utils/Logger";
import { LoginResponse } from "../data/response/LoginResponse";
import { RegionResponse } from "../data/response/RegionResponse";
import { LoginRequest } from "../data/request/LoginRequest";
import LoginClient from "../data/api/LoginClient";
import { useApi } from "../../../service/ApiContext";
import Loader, {
  LocalStorage,
  UserDeviceStorage,
} from "./../../../utils/Utils";
import { useDispatch } from "react-redux";
import { logActionEvent } from "../../../analytics/analytics_utils";
import { useQueryClient } from "react-query";
import CommonUtils from "../../../utils/Common_Utils";
import analytics_strings from "../../../analytics/analytics_strings";
import { clearProfileKeys } from "../data/redux/LoginReducer";
import AssessmentQuestionModuleApiService from "../../assessment_question/data/api_services/QuestionModuleApi";
import { InitiateGooglePayUPI } from "../../../utils/InitiateGooglePayUPI";
import { useAlert } from "../../../components/AlertContextComponent";
import GreenSuccessInfoPopup from "../../../components/GreenSuccessSnackComponent";
import { setShowChatBotOnLogin, setChatBotMode } from "../../../store/networkListener";

const LoginComponentVersionTwo: React.FC = () => {
  const [passwordVisible, setPasswordVisible] = useState<boolean>(false);
  const [emailError, setEmailError] = useState<string>("");
  const [uidError, setUidError] = useState<string>("");
  const [loginButtonHide, setLoginButtonHide] = useState<boolean>(false);

  const [loginError, setLoginError] = useState<string>("");
  const [passwordError, setPasswordError] = useState<string>("");
  const [emailOrUid, setEmailOrUid] = useState<string>(""); // Email or UID
  const [password, setPassword] = useState<string>("");
  const [selectedLoginType, setSelectedLoginType] = useState<string>("email"); // Track login type
  const dispatch = useDispatch();
  const questionModuleApiService = AssessmentQuestionModuleApiService(); //To Clear Assessment
  const { showAlert } = useAlert();
  const navigate = useNavigate();
  const api = useApi();
  const [showNotification, setShowNotification] = useState<string | null>(null);
  const isLoggingIn = useRef<boolean>(false); //Prevent Login api is calling on button enter click

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmailOrUid(e.target.value);

    if (selectedLoginType === "email") {
      const checkValue = e.target.value.replace(/\s/g, "");
      if (validateEmailAddressLoginPage(checkValue)) {
        setEmailError("");
      } else {
        setEmailError(strings.validation.loginEmailError);
      }
    } else {
      // Validate as UID
      if (!e.target.value.trim()) {
        setUidError(strings.validation.uidError); // Show error if UID is empty
        // } else if (validateUid(e.target.value)) {
        //   setEmailError("");
        // } else {
      } else {
        setEmailError(""); // Show error if UID is invalid
      }
    }
  };

  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(e.target.value);
    const passwordValidationError = validatePassword(e.target.value);
    setPasswordError(passwordValidationError);
  };

  const userLogin = async () => {
    Loader.showLoading("Loading...");
    const param: LoginRequest = {
      email_address: emailOrUid.trim().toLowerCase(), //(12-09-2025) Rana, Vivin, and Prashanth told me to send the email in lowercase.
      entity_password: password,
      entity_type: "USER",
    };
    LocalStorage.setLocalData("email_address", param.email_address);

    const url = LoginClient.token;
    try {
      await api
        .post<LoginResponse>(url, param)
        .then((res) => {
          if (res.data.error != null) {
            setLoginButtonHide(false); //Login button enable
            selectedLoginType === "email"
              ? setLoginError(res.data.error)
              : selectedLoginType !== "email" &&
                  res.data.error === "Email does not exist."
                ? setLoginError("UID does not exist.")
                : setLoginError(res.data.error);

            logActionEvent(analytics_strings.analytics_events.loginFailed, {
              emailId: param.email_address,
              detail: res.data.error,
            });
          } else {
            if (res.data.previous_session) {
              //Active Session Detected
              showAlert({
                identity: "multiuser-warning",
                show: true,
                title: "Warning!",
                message:
                  "It looks like <b> you're already logged in on another device or browser.<b>",
                bottomHintText:
                  "To continue here, you can log out from the other session.",
                deviceDetails: [
                  res.data.previous_session.device,
                  res.data.previous_session.location,
                  CommonUtils.loginTimeFormatLocalTime(
                    res.data.previous_session.login_time,
                  ),
                ],
                button1Text: "Log out from other session",
                button2Text: "Cancel",
                alertType: "error",
                multipleLoginProp: "Session_Detected",
                onlyNeedOneButton: false,
                btn1onPressed: () => {
                  setLoginButtonHide(true); //Login button disabled because no relogin have to happen
                  //Session Takover api call
                  SessionTakeOverApiCall();
                },
                btn2onPressed: () => {
                  setLoginButtonHide(false); //Login button enable
                },
                btn2close: true,
              });
              return;
            }
            const deviceId_header = res.headers["device-id"];
            if (res.headers["device-id"]) {
              UserDeviceStorage.setDeviceId(
                emailOrUid.trim().toLowerCase(),
                deviceId_header,
              ); //(12-09-2025) Rana, Vivin, and Prashanth told me to send the email in lowercase.
            }
            Logger.info("response", res.data);
            LocalStorage.setLocalData("access_token", res.data.access_token);
            //Storing Login Credentials for Refreash Token
            LocalStorage.setLocalData("entity_password", password);
            logActionEvent(analytics_strings.analytics_events.loginSuccess, {
              emailId: param.email_address,
              message: analytics_strings.analytics_events.loginSuccess,
            });
            //Choose user type
            const loginUserType =
              selectedLoginType == "email" ? "CANDIDATE" : "STUDENT";
            LocalStorage.setLocalData("userType", loginUserType);
            dispatch(setChatBotMode("floating"));
            dispatch(setShowChatBotOnLogin(true));
            navigate(strings.routing.initalDashboardPage, {
              state: { viaLogin: true },
            });
          }
        })
        .catch((error) => {
          Logger.info("error response", error);
          logActionEvent(analytics_strings.analytics_events.loginException, {
            emailId: param.email_address,
            exception: error,
          });
          // setEmailError("Failed to login. Please try again.");
        });
    } catch (error) {
      Logger.info("error response", error);
      // setEmailError("Failed to login. Please try again.");
    } finally {
      Loader.dismissLoading();
    }
  };
  const SessionTakeOverApiCall = async () => {
    Loader.showLoading("Loading...");
    const param = {
      entity_email_address: emailOrUid.trim().toUpperCase(), //(12-09-2025) Rana, Vivin, and Prashanth told me to send the email in lowercase.
      entity_type: "USER",
    };
    try {
      await api
        .post<LoginResponse>(LoginClient.sessionTakeover, param)
        .then((res) => {
          if (res.data.detail && res.data.detail !== null) {
            //Successsfully Logged out of other session
            handleShowNotification(res.data.detail);
            setTimeout(() => {
              userLogin();
            }, 3000);
          } else {
            setLoginButtonHide(false); //Login button enable
            showAlert({
              show: true,
              title: "Error",
              message: res.data.error,
              button1Text: "Cancel",
              alertType: "error",
              onlyNeedOneButton: true,
              btn1onPressed: () => {},
            });
          }
          Logger.info("response", res.data);
        })
        .catch((error) => {
          Logger.info("error response", error);
        });
    } catch (error) {
      Logger.info("error response", error);
    } finally {
      Loader.dismissLoading();
    }
  };
  useEffect(() => {
    const handleKeyPress = (e: KeyboardEvent) => {
      if (e.key !== "Enter") return;

      // Trigger login only if the tab/page is active
      if (document.hasFocus()) {
        if (isLoggingIn.current === true) {
          return;
        } else {
          isLoggingIn.current = true;
          handleLogin();
        }
      }
    };

    window.addEventListener("keydown", handleKeyPress);
    return () => window.removeEventListener("keydown", handleKeyPress);
  }, [emailOrUid, password]);

  const handleLogin = () => {
    let hasError = false;

    if (!emailOrUid.trim()) {
      setEmailError(
        selectedLoginType === "email"
          ? strings.validation.loginEmailError
          : strings.validation.uidError,
      );
      hasError = true;
    }

    if (!password.trim()) {
      setPasswordError(strings.validation.passwordError);
      hasError = true;
    } else {
      const passwordValidationError = validatePassword(password);
      if (passwordValidationError) {
        setPasswordError(passwordValidationError);
        hasError = true;
      } else {
        setPasswordError("");
      }
    }

    if (emailError == "" && passwordError === "" && !hasError) {
      userLogin();
    }
  };
  //Success SnackBar
  const handleShowNotification = (msg: string) => {
    setShowNotification(msg);
  };

  const handleCloseNotification = () => {
    setShowNotification(null);
  };
  const handleRadioChange = (value: "email" | "uid") => {
    setSelectedLoginType(value);
    // Clear the email/UID and password fields when radio changes
    setEmailOrUid("");
    setPassword("");
    setEmailError("");
    setPasswordError("");
    setLoginError("");
  };
  useEffect(() => {
    dispatch(clearProfileKeys());
    questionModuleApiService.clearAssessmentLocalStorage();
    CommonUtils.setFaviconTitle(null, null);
  }, []);
  return (
    <div className="v2-login-form-wrapper">
      <h1 className="v2-login-heading">{strings.login.loginButton}</h1>

      <p className="v2-login-subtitle">
        Sign in to continue your learning journey.{" "}
      </p>

      {/* LOGIN TYPE SWITCH */}
      <div className="v2-login-radio-wrapper">
        <div
          className={`v2-login-radio-option ${
            selectedLoginType === "email" ? "active" : ""
          }`}
        >
          <Input
            type="radio"
            name="flexRadioDefault"
            id="flexRadioDefault1"
            value="email"
            defaultChecked
            onChange={() => handleRadioChange("email")}
          />

          <Label for="flexRadioDefault1" check>
            Email Id
          </Label>
        </div>

        <div
          className={`v2-login-radio-option ${
            selectedLoginType === "uid" ? "active" : ""
          }`}
        >
          <Input
            type="radio"
            name="flexRadioDefault"
            id="flexRadioDefault2"
            value="uid"
            onChange={() => handleRadioChange("uid")}
          />

          <Label for="flexRadioDefault2" check>
            UID
          </Label>
        </div>
      </div>

      <Form className="v2-login-form">
        {/* EMAIL / UID */}
        <FormGroup className="v2-login-form-group">
          <Label for="emailOrUid" className="v2-login-label">
            {selectedLoginType === "email" ? strings.login.emailLabel : "UID"}
          </Label>

          <Input
            value={emailOrUid}
            type="text"
            name="emailOrUid"
            id="emailOrUid"
            maxLength={50}
            onChange={handleInputChange}
            className={`v2-login-input ${
              emailError || uidError ? "v2-login-input-error" : ""
            }`}
          />

          {(emailError || uidError) && (
            <div className="v2-login-error">{emailError || uidError}</div>
          )}
        </FormGroup>

        {/* PASSWORD */}
        <FormGroup className="v2-login-form-group">
          <div className="v2-login-password-header">
            <Label for="password" className="v2-login-label">
              {strings.login.password}
            </Label>

            <div
              className="v2-login-show-password"
              onClick={togglePasswordVisibility}
            >
              <i
                className={`fas ${passwordVisible ? "fa-eye-slash" : "fa-eye"}`}
              ></i>

              <span>{passwordVisible ? "Hide" : "Show"}</span>
            </div>
          </div>

          <Input
            value={password}
            type={passwordVisible ? "text" : "password"}
            name="password"
            id="password"
            onChange={handlePasswordChange}
            className={`v2-login-input ${
              passwordError ? "v2-login-input-error" : ""
            }`}
          />

          {passwordError && (
            <div className="v2-login-error">{passwordError}</div>
          )}
        </FormGroup>

        {/* FORGOT PASSWORD */}
        <div className="v2-login-forgot-wrapper">
          <span
            className="v2-login-forgot-password"
            onClick={() => navigate(strings.routing.forgotPasswordpage)}
          >
            {strings.login.forgotPassword}
          </span>
        </div>

        {/* LOGIN ERROR */}
        {loginError && <div className="v2-login-main-error">{loginError}</div>}

        {/* BUTTON */}
        <Button
          className={`v2-login-button ${
            emailOrUid.trim() !== "" &&
            password.trim() !== "" &&
            !emailError &&
            !passwordError
              ? "v2-login-button-active"
              : ""
          }`}
          onClick={handleLogin}
          disabled={loginButtonHide}
        >
          Sign In
        </Button>

        {/* SIGNUP */}
        <p className="v2-login-signup-text">
          New here?{" "}
          <span
            className="v2-login-signup-link"
            onClick={() => navigate(strings.routing.signupPage)}
          >
            Join for free{" "}
          </span>
        </p>
      </Form>

      {showNotification && (
        <GreenSuccessInfoPopup
          message={showNotification}
          onClose={handleCloseNotification}
        />
      )}
    </div>
  );
};

export default LoginComponentVersionTwo;
